import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {HostInfobras, HttpHeaderToken} from '../general/variables';
import { Infobras } from '../models/Infobras';
import { InfobraConsulta } from '../models/personalizados/InfobraConsulta';
import { EjecucionInfobra } from '../models/EjecucionInfobra';
import { EventoInfobra } from '../models/EventoInfobra';
import { ModalidadInfobra } from '../models/ModalidadEjec';

@Injectable({
  providedIn: 'root'
})

export class InfobrasService {

  constructor(protected http: HttpClient) { }

  // tslint:disable-next-line: ban-types
  url: String = `${HostInfobras}`;
  urlInfobras: String = `${HostInfobras}`;
  ListarInfobras(infobras: Infobras) {

    return this.http.get<Infobras[]>(`${this.urlInfobras}/INFOBRAS/getListado/${infobras.departamento}/${infobras.provincia}/${infobras.distrito}`, HttpHeaderToken());

  }

  listarInfobras(infobra: InfobraConsulta) {
    return this.http.post<any[]>(`${this.urlInfobras}/INFOBRAS/getListado/`, infobra, HttpHeaderToken());
  }
  obtenerEjecucionObras() {
    return this.http.get<EjecucionInfobra[]>(`${this.urlInfobras}/INFOBRAS/getEjecucion`, HttpHeaderToken()); // getEstado
  }

  // getEjecucion

  obtenerEventos() {
    return this.http.get<EventoInfobra[]>(`${this.urlInfobras}/INFOBRAS/getEvento`, HttpHeaderToken());
  }

  obtenerModalidad() {
    return this.http.get<ModalidadInfobra[]>(`${this.urlInfobras}/INFOBRAS/getObrasModalidad`, HttpHeaderToken());
  }

  // getListaTipoEjecucion(){

  //   return this.http.get<TipoEjecucion[]>(`${this.urlInfobras}/INFOBRAS/getEjecucion`);

  // }

}
